import { msg } from '@lingui/core/macro';
import { translateLazy } from '@utils/translations.ts';

const ACTION_TITLE = {
    ACTION: msg`Actions`,
};

export const COMMON_ACTION_COLUMN_PROPS = {
    key: '__actions',
    title: translateLazy(ACTION_TITLE.ACTION),
    align: 'center',
    fixed: 'right',
    width: '110px',
} as const;

export const SEARCH_THROTTLE_MS = 400 as const;
export const SEARCH_DEBOUNCE_MS = 400 as const;
export const MIN_SEARCH_CHARS = 2 as const;
